export default "__VITE_ASSET__wp4bYo0F__"